module.exports = __webpack_public_path__ + "static/img/bernathlevente_grad.489df32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/bernathlevente_grad.jpg
// module id = 372
// module chunks = 2